let agentReadyTimeout;

export function abort() {
	clearTimeout(agentReadyTimeout);
}

export function waitForAgentReady(resolve) {
	agentReadyTimeout = setTimeout(resolve, 10000);
}

export function agentReady() {
	clearTimeout(agentReadyTimeout);
}
